module.exports = __webpack_public_path__ + "josif_pancic_cajevi.jpg?0db52f1eb9758b013d74a7154e1d0b47";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/josif_pancic/josif_pancic_cajevi.jpg
// module id = 75
// module chunks = 0